import { render, staticRenderFns } from "./projectly.vue?vue&type=template&id=5aa995f5&scoped=true&"
import script from "./projectly.vue?vue&type=script&lang=js&"
export * from "./projectly.vue?vue&type=script&lang=js&"
import style0 from "./projectly.vue?vue&type=style&index=0&id=5aa995f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa995f5",
  null
  
)

export default component.exports